<script>
import { QSelect } from 'quasar'
import FieldIconMixin from '../field/FieldIconMixin.js'
import FieldProxyMixin from '../field/FieldProxyMixin.js'
import FieldSelectMixin from '../field/FieldSelectMixin.js'

export default {
  mixins: [FieldIconMixin, FieldProxyMixin, FieldSelectMixin],
  data () {
    return {
      selectOptions: null
    }
  },
  created () {
    this.selectOptions = this.validOptions
  },
  render (createElement) {
    const useInput = this.useInput ?? (this.validOptions.length > 7)
    return createElement(QSelect, {
      ref: 'input',
      props: {
        ...this.$props,
        useInput: useInput,
        hideSelected: this.hideSelected ?? useInput,
        fillInput: this.fillInput ?? useInput,
        options: this.selectOptions,
        label: this.label ?? this.enumType.label,
        useChips: this.multiple,
        disable: this.disable ?? !this.selectOptions?.length
      },
      attrs: { ...this.$attrs },
      on: Object.assign({
        filter: (val, update) => {
          this.onFilterOptions(val, update)
        }
      }, this.$listeners),
      scopedSlots: Object.assign({
        prepend: this.slotPrependIcon(createElement),
        option: this.slotOption(createElement)
      }, this.$scopedSlots)
    })
  }
}
</script>
